export default __webpack_public_path__ + "static/media/art.65d73127.png";